<template>
    <design-2021-files-table-component
        :user-id="authId"
        :project-id="projectId"
        :is-student="authIsStudent">
    </design-2021-files-table-component>
</template>

<script>
    import Design2021FilesTableComponent from '../../files/design-2021-files-table-component.vue';

    export default {
        name: 'design-2021-project-show-files-component',

        components: { Design2021FilesTableComponent },

        props: ['projectId'],

        data() {
            return {
                files: this.filesIn,
                authId: AuthId,
                authIsStudent: AuthIsStudent,
            };
        },
    };
</script>

<style scoped lang="scss">

</style>
